import React, { Component } from 'react'
import styled from 'styled-components'
import theme from 'ui/styles/theme'
import easing from 'ui/styles/easing'

const TransitionPath = styled.path`
  transition: fill 0.3s ${easing.easeOutCubic};
`

export default class IconMonitoring extends Component {
  render() {
    const { hover, active } = this.props

    const lineStyle = {
      "fill": "none",
      "stroke-dasharray": "30 32",
      "stroke-miterlimit": "10",
      "stroke-width": "10px"
    }

    return (
      <svg
        width="55"
        height="60"
        viewBox="150 0 600 700" xmlns="http://www.w3.org/2000/svg">
        <TransitionPath
          d="M605.56,279.95c-3.81,3.81-10,3.81-13.81,0s-3.81-10,0-13.81,10-3.81,13.81,0,3.81,10,0,13.81Z"
          fill={hover || active ? theme.colors.primary : theme.colors.secondary}
        />
        <TransitionPath
          d="M598.66,251.28c12.47,0,24.2,4.86,33.02,13.68l71.76,71.76c8.82,8.82,13.68,20.54,13.68,33.02s-4.86,24.2-13.68,33.02l-30.32,30.32c-8.82,8.82-20.54,13.68-33.02,13.68s-24.2-4.86-33.02-13.68l-71.76-71.76c-8.82-8.82-13.68-20.54-13.68-33.02s4.86-24.2,13.68-33.02l30.32-30.32c8.82-8.82,20.54-13.68,33.02-13.68M598.66,241.28c-14.51,0-29.02,5.53-40.09,16.6l-30.32,30.32c-22.14,22.14-22.14,58.04,0,80.18l71.76,71.76c11.07,11.07,25.58,16.6,40.09,16.6s29.02-5.54,40.09-16.6l30.32-30.32c22.14-22.14,22.14-58.04,0-80.18l-71.76-71.76c-11.07-11.07-25.58-16.6-40.09-16.6h0Z"
          fill={hover || active ? theme.colors.primary : theme.colors.secondary}
        />
        <TransitionPath
          d="M544.79,384.93c7.63,7.63,31.05,31.05,38.67,38.67l-8.29,52.49-4.14,4.14-82.87-82.87,4.14-4.14,52.49-8.29M548.26,374.26l-5.03.79-52.49,8.29-3.21.51-2.3,2.3-4.14,4.14-7.07,7.07,7.07,7.07,82.87,82.87,7.07,7.07,7.07-7.07,4.14-4.14,2.3-2.3.51-3.21,8.29-52.49.79-5.03-3.6-3.6-9.41-9.41-29.27-29.27-3.6-3.6h0Z"
          fill={hover || active ? theme.colors.primary : theme.colors.secondary}
        />
        <TransitionPath
          style={lineStyle}
          d="M529.6,662.98l41.44-182.75"
          fill={hover || active ? theme.colors.primary : theme.colors.secondary}
          stroke={hover || active ? theme.colors.primary : theme.colors.secondary}
        />
        <TransitionPath
          style={lineStyle}
          d="M253.98,457.98l234.17-60.62"
          fill={hover || active ? theme.colors.primary : theme.colors.secondary}
          stroke={hover || active ? theme.colors.primary : theme.colors.secondary}
        />
        <TransitionPath
          d="M528.93,236.04l-8.53,8.53-96.38-79.81-285.67,233.65-7.61-9.3,293.32-239.91,104.86,86.83Z"
          fill={hover || active ? theme.colors.primary : theme.colors.secondary}
        />
        <TransitionPath
          d="M669.13,482.98v218.21H176.45v-295.61h12.02v283.59h468.65v-206.19h12.02ZM633.26,217.37l8.96-8.96c-23.77-23.77-62.46-23.77-86.23,0l8.96,8.96c18.83-18.83,49.48-18.83,68.31,0ZM671.9,178.74l8.96-8.96c-45.08-45.08-118.43-45.08-163.51,0l8.96,8.96c40.14-40.14,105.45-40.14,145.58,0ZM652.58,198.05l8.96-8.96c-34.43-34.43-90.44-34.43-124.87,0l8.96,8.96c29.49-29.49,77.46-29.49,106.95,0Z"
          fill={hover || active ? theme.colors.primary : theme.colors.secondary}
        />
      </svg>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/ProductsNew/IconMonitoringSolutions.js